/*jshint esversion: 8 */
const XLSX = require("xlsx");

const importExcel = async () => {
  const rst = [];
  return rst;
};

const exportExcel = async (data, header, xlsxName) => {
  const sheet = [header, ...data];
  const worksheet = XLSX.utils.json_to_sheet(sheet, {
    // header: ["orderNumber"],
    // 跳过 Header, 就是把原来表格数据的表头去掉了, headerReplace渲染的数据 "冒充" 表头了
    skipHeader: true,
  });

  const newWorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(newWorkBook, worksheet, "SheetJS");
  return XLSX.writeFile(newWorkBook, `${xlsxName}.xlsx`);
};

export {
  importExcel,
  exportExcel,
};
